import { Drawer, Table, Button, message, Space, Tooltip, Image } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EyeOutlined, DownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import { useRepositoryDownload, useRepositoryDeleteFile } from "Components/DeviceBackup/queries";
import FileSaver from "file-saver";
import { useAppSelector, useAppDispatch } from "store/hook";
import { ReportRecord } from "Utility/Types/report";
import { useSearchColumn } from "Utility/hooks/useSearchColumn";
import { setPDFVisible } from "Components/Report/reportSlice";
import type { ColumnsType } from "antd/lib/table";
interface ReportHistoryProps {
  // reportHistoryVisible: boolean;
  setPDF: (arg: File | undefined) => void;
  record: any;
  reportHistoryVisible: boolean;
  setReportHistoryVisible: (arg: boolean) => void;
  setRecord: any;
  setRecordIndex: (arg: number | undefined) => void;
  recordIndex: number | undefined;
  data: ReportRecord[] | undefined;
  loading: boolean;
  fetching: boolean;
  setLogoUrl: (arg: string) => void;
  setLogoVisible: (arg: boolean) => void;
}

const ReportHistory = ({
  record,
  setPDF,
  reportHistoryVisible,
  setReportHistoryVisible,
  setRecord,
  // setRecordIndex,
  recordIndex,
  data,
  loading,
  fetching,
  setLogoUrl,
  setLogoVisible,
}: ReportHistoryProps) => {
  const disp = useAppDispatch();
  const { loginCid, stateCid, level } = useAppSelector((state) => state.global);
  // const [reportHistoryVisible, setReportHistoryVisible] = useState(false);
  // const [PDF, setPDF] = useState<any>(undefined);
  const { t } = useTranslation();
  // const [isModalVisible, setPDFVisible] = useState(false);
  const { mutateAsync: downloadMutation } = useRepositoryDownload();
  const { mutateAsync: deleteMutation, isLoading: deleteLoading } = useRepositoryDeleteFile(stateCid);
  // const list = data?.[recordIndex || 0]?.pdf_list || [];
  const list = [...(data?.[recordIndex || 0]?.pdf_list || [])].reverse();

  const getColumnSearchProps = useSearchColumn();
  const cid = level === "super_super" && stateCid !== "" ? stateCid : loginCid;
  const deletedKey = "deletedKey";
  const downloadReport = (filename: string) => {
    return downloadMutation({ cid, name: filename, type: "REPORT" });
  };
  const deleteReport = async (filename: string) => {
    message.loading({ content: t("ISMS.Deleting"), key: deletedKey });

    try {
      await deleteMutation({
        level,
        stateCid,
        loginCid,
        record: { cid, name: filename, type: "REPORT" },
      });
      message.success({ content: "Deletion successful", key: deletedKey, duration: 2 });
    } catch (error) {
      message.error({ content: "Deletion failed", key: deletedKey, duration: 2 });
    } finally {
    }
  };

  const columns: ColumnsType<ReportRecord["pdf_list"][number]> = [
    {
      title: "File Name",
      dataIndex: "filename",
      ...getColumnSearchProps("filename"),
    },
    // {
    //   title: "Generated Time",
    //   dataIndex: "date",
    // },
    {
      title: "Size(MB)",
      // dataIndex: "size",
      sorter: (a, b) => a.size - b.size,
      render: ({ size }) => (size / 1024 / 1024).toFixed(2),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    // },
    {
      title: "Action",

      render: ({ filename }: { filename: string }) => {
        return (
          <Space size={1}>
            <Tooltip title="View">
              <Button
                type="text"
                onClick={() => {
                  downloadReport(filename).then(({ data }) => {
                    // console.log(data);
                    if (filename.split(".")[1] === "logo") {
                      const objectURL = URL.createObjectURL(data);

                      setLogoVisible(true);
                      setLogoUrl(objectURL);
                    } else {
                      disp(setPDFVisible(true));

                      setPDF(data);
                    }
                  });
                }}
              >
                <EyeOutlined />
              </Button>
            </Tooltip>
            <Tooltip title="Download">
              <Button
                type="text"
                onClick={() =>
                  downloadReport(filename)
                    .then(({ data }) => {
                      FileSaver.saveAs(data, filename);
                    })
                    .catch(() => {
                      message.error(t("ISMS.Fail"));
                    })
                }
              >
                <DownloadOutlined />
              </Button>
            </Tooltip>

            <Tooltip title="Delete">
              <Button type="text" onClick={() => deleteReport(filename)}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      {/* <Button
        type="text"
        onClick={() => {
          // setRecord(record);
          setReportHistoryVisible(true);
        }}
      >
        <BsCardList />
      </Button> */}
      <Drawer
        getContainer={false}
        title="Report History"
        visible={reportHistoryVisible}
        onClose={() => {
          setReportHistoryVisible(false);
          disp(setPDFVisible(false));
          setPDF(undefined);
          setRecord(undefined);
        }}
        width={"90%"}
        destroyOnClose
        // maskClosable={false}
      >
        {/* <ViewPDF data={PDF} isModalVisible={isModalVisible} setPDFVisible={setPDFVisible} /> */}
        <Table
          loading={loading || deleteLoading || fetching}
          columns={columns}
          dataSource={list
            ?.filter((item: any) => item.filename.endsWith(".pdf"))
            .map((subItem: any) => ({
              ...subItem,
              key: subItem._id, // 確保 key 唯一
            }))}
        />
      </Drawer>
    </>
  );
};

export default ReportHistory;

export const LogoImage = ({
  LogoVisible,
  setLogoVisible,
  LogoUrl,
}: {
  LogoVisible: boolean;
  setLogoVisible: (arg: boolean) => void;
  LogoUrl: string;
}) => {
  return (
    <Image
      width={200}
      style={{ display: "none" }}
      src={LogoUrl}
      preview={{
        visible: LogoVisible,
        src: LogoUrl,
        onVisibleChange: (value) => {
          setLogoVisible(value);
        },
      }}
    />
  );
};
